import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=ecda650c&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"
import style0 from "./admin.vue?vue&type=style&index=0&id=ecda650c&prod&lang=scss"
import style1 from "./admin.vue?vue&type=style&index=1&id=ecda650c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecda650c",
  null
  
)

export default component.exports